import React from "react";
import { Image } from "atomize";

// import Images
import eBikeLogo from "../../assets/images/eBike-logo.svg";

export const EbikeLogo = () => {
  return <Image src={eBikeLogo} w="116px" alt="eBike0logo" />;
};
